<template>
  <b-container>
    <div class="row">
      <div class="col-sm">
        <advisory-board v-if="$auth.user().user_type === 'entrepreneur'" />
        <advisory-membership v-if="$auth.user().user_type === 'advisor'" />
      </div>
    </div>

    <b-row class="justify-content-center mt-3">
      <b-col lg="6">
        <div class="box">
          <b-button
            variant="secondary"
            class="float-right"
            :to="
              $auth.user().user_type === 'advisor'
                ? '/entrepreneurs'
                : '/advisors'
            "
          >
            Explore
            {{
              $auth.user().user_type === 'advisor'
                ? 'Entrepreneurs'
                : 'Advisors'
            }}
          </b-button>

          <h2>
            Top
            {{
              $auth.user().user_type === 'advisor' ? 'Entrepreneur' : 'Advisor'
            }}
            Matches
          </h2>

          <div class="d-flex justify-content-center" v-if="loading">
            <b-spinner class="mx-auto">Loading...</b-spinner>
          </div>

          <div
            class="box-inner tile-user"
            v-for="match in matches"
            :key="match.uuid"
          >
            <b-row class="align-items-center">
              <b-col cols="9">
                <div class="media">
                  <router-link
                    :to="`/user/${match.uuid}`"
                    :title="`${match.first_name} ${match.last_name}`"
                  >
                    <img
                      class="img-fluid rounded-circle mr-16"
                      style="width: 64px;"
                      :src="match.avatar"
                    />
                  </router-link>

                  <div class="media-body">
                    <h3 class="mt-0 mb-4">
                      <router-link
                        :to="`/user/${match.uuid}`"
                        :title="`${match.first_name} ${match.last_name}`"
                      >
                        {{ match.first_name }} {{ match.last_name }}
                      </router-link>
                    </h3>

                    <p>{{ match.bio }}</p>

                    <span class="badge badge-highlight" v-if="match.experience">
                      {{ experience[match.experience] }}
                    </span>
                  </div>
                </div>
              </b-col>

              <b-col cols="3">
                <b-btn variant="primary" size="xs" @click="openModal(match)">
                  Book Meeting
                </b-btn>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>

      <b-col lg="6">
        <div class="box">
          <h2>Upcoming Events</h2>

          <b-btn
            class="w-100 mb-2"
            variant="primary"
            v-if="unreviewedMeetings > 0"
            :to="'/reviews'"
          >
            {{ formatUnreviewedMeetingsString() }}
          </b-btn>

          <p class="text-center" v-if="meetings.length === 0 && !loading">
            <em>No upcoming events.</em>
          </p>

          <div
            class="box-inner tile-events"
            v-for="meeting in meetings"
            :key="meeting.uuid"
          >
            <div class="media">
              <div class="event-date">
                {{ meeting.date_day }}
                <div class="event-date-month">
                  {{ meeting.date_month }}
                </div>
              </div>

              <div class="media-body">
                <h5 class="mb-4">
                  <span v-if="meeting.meeting_type === 'in-person'">
                    In-Person
                  </span>

                  <span v-if="meeting.meeting_type === 'remote'">
                    Remote                    
                  </span>

                  Meeting with

                  <span v-if="meeting.inviter.uuid === $auth.user().uuid">
                    {{ meeting.invitee.first_name }}
                    {{ meeting.invitee.last_name }}
                  </span>

                  <span v-if="meeting.invitee.uuid === $auth.user().uuid">
                    {{ meeting.inviter.first_name }}
                    {{ meeting.inviter.last_name }}
                  </span>
                </h5>

                <p class="mb-4">{{ meeting.message }}</p>
                <p>{{ meeting.start_time }} - {{ meeting.end_time }}</p>
                <p v-if="meeting.meeting_type === 'remote'">{{ meeting.invitee.remote_location }}</p>
                <p v-if="meeting.meeting_type === 'in-person'">{{ meeting.invitee.in_person_location }}</p>
              </div>
            </div>

            <b-btn
              variant="primary"
              block
              disabled
              v-if="
                meeting.inviter.uuid === $auth.user().uuid &&
                  meeting.status === 'pending'
              "
            >
              Pending
            </b-btn>

            <b-row
              v-if="
                meeting.invitee.uuid === $auth.user().uuid &&
                  meeting.status === 'pending'
              "
            >
              <!-- Only should appear if advisor and invited by entrepreneur  -->
              <b-col
                cols="12"
                v-if="
                  $auth.user().user_type === 'advisor' &&
                    meeting.inviter.user_type === 'entrepreneur'
                "
              >
                <!-- Need to show assignment button and educational summary if needed -->
                <b-btn
                class="mb-3"
                  v-if="selectedResources[meeting.uuid] == null"
                  @click="openResourceSelection(meeting)"
                >
                  Attach Resource</b-btn
                >
                <educational-item-summary v-if="selectedResources[meeting.uuid] != null" :resource="selectedResources[meeting.uuid]" actionTitle="Remove" v-on:action-button-tapped="removeResource(meeting)"></educational-item-summary>
              </b-col>
              <b-col>
                <b-btn variant="secondary" block @click="accept(meeting.uuid)">
                  Approve
                </b-btn>
              </b-col>

              <b-col>
                <b-btn variant="danger" block @click="decline(meeting.uuid)">
                  Decline
                </b-btn>
              </b-col>
            </b-row>

            <div
              v-if="
                meeting.status === 'approved' &&
                  meeting.educational_item != null
              "
            >
              <b-row>
                <b-col cols="12" class="mb-2">
                  You<span v-if="$auth.user().user_type === 'entrepreneur'">r advisor has</span> attached the following Educational Resource
                  to this meeting.
                </b-col>
                <b-col cols="12">
                  <educational-item-summary
                    :resource="meeting.educational_item"
                    actionTitle="View"
                    v-on:action-button-tapped="
                      viewResource(meeting.educational_item)
                    "
                  ></educational-item-summary>
                </b-col>
              </b-row>
            </div>
            <a
              class="btn btn-block btn-primary"
              v-if="meeting.status === 'approved'"
              :href="formatEmailLink(meeting)"
            >
              Contact

              <span v-if="meeting.inviter.uuid === $auth.user().uuid">
                {{ meeting.invitee.user_type | capitalize }}
              </span>

              <span v-if="meeting.invitee.uuid === $auth.user().uuid">
                {{ meeting.inviter.user_type | capitalize }}
              </span>
            </a>
          </div>
        </div>
      </b-col>
    </b-row>

    <schedule-modal
      :show="showScheduleModal"
      :user="user"
      @dismiss="showScheduleModal = false"
    />
    <educational-item-selection-modal :show="showResources" @dismiss="showResources = false; selectedMeeting = null" v-on:resource-selected="resourceSelected($event)"></educational-item-selection-modal>
  </b-container>
</template>

<script>
import AdvisoryBoard from '@/components/advisors/AdvisoryBoard'
import AdvisoryMembership from '@/components/advisors/AdvisoryMembership'
import ScheduleModal from '@/components/advisors/ScheduleModal'
import EducationalItemSummary from '@/components/educational_resources/EducationalItemSummary'
import EducationalItemSelectionModal from '../components/educational_resources/EducationalItemSelectionModal.vue'

export default {
  name: 'Dashboard',
  components: {
    AdvisoryBoard,
    AdvisoryMembership,
    ScheduleModal,
    EducationalItemSummary,
    EducationalItemSelectionModal
  },
  data() {
    return {
      loading: false,
      matches: [],
      meetings: [],
      unreviewedMeetings: 0,
      user: null,
      showScheduleModal: false,
      experience: {
        lt_1: '< 1 year',
        '1_5': '1-5 years',
        '5_10': '5-10 years',
        '10_20': '10-20 years',
        '20p': '20+ years',
      },
      selectedMeeting: null,
      selectedResources: {},
      showResources: false,
    }
  },
  mounted() {
    this.loading = true

    const type =
      this.$auth.user().user_type === 'advisor' ? 'entrepreneurs' : 'advisors'

    this.$http
      .get(`users/${type}`, {
        params: {
          page_count: 6,
        },
      })
      .then(
        (res) => {
          this.matches = res.data.data
        },
        () => {}
      )
      .finally(() => {
        this.loading = false
      })

    this.loadCalendar()
  },
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.substr(1)
    },
  },
  methods: {
    async loadCalendar() {
      const unreviewedMeetings = await this.$http.get('meetings/unreviewed')
      this.unreviewedMeetings = unreviewedMeetings.data.unreviewed_count

      this.$http
        .get('meetings/upcoming', {
          params: {
            page_count: 5,
            hide_declined: true,
          },
        })
        .then(
          (res) => {
            this.meetings = res.data.data
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    openModal(user) {
      this.user = user
      this.showScheduleModal = true
    },
    accept(uuid) {
      // Update to check for selected resource
      let resourceId = null
      if (this.selectedResources[uuid]) {
        resourceId = this.selectedResources[uuid].id.toString()
      }
      this.$http
        .post(`meetings/accept`, {
          meeting_uuid: uuid,
          item_id: resourceId,
        })
        .finally(this.loadCalendar)
    },
    decline(uuid) {
      this.$bvModal
        .msgBoxConfirm('Are your sure you want to decline this invitation?', {
          centered: true,
          title: 'Decline Invitation',
        })
        .then((value) => {
          if (!value) {
            return
          }

          this.$http.post(`meetings/decline/${uuid}`).finally(this.loadCalendar)
        })
    },
    formatEmailLink(meeting) {
      let address = meeting.inviter_email
      if (meeting.inviter.uuid === this.$auth.user().uuid) {
        address = meeting.invitee_email
      }
      return `mailto:${address}`
    },
    formatUnreviewedMeetingsString() {
      return this.unreviewedMeetings === 1
        ? `Review 1 Unreviewed Meeting`
        : `Review ${this.unreviewedMeetings} Unreviewed Meetings`
    },
    viewResource(resource) {
      let routeData = this.$router.resolve({
        path: `/resources/${resource.uuid}`,
      })
      window.open(routeData.href, '_blank')
    },
    openResourceSelection(meeting) {
      this.selectedMeeting = meeting
      this.showResources = true
    },
    resourceSelected(resource) {
      if (!this.selectedMeeting) { return }
      // this.selectedResources[this.selectedMeeting.uuid] = resource
      this.$set(this.selectedResources, this.selectedMeeting.uuid, resource)
      this.selectedMeeting = null
      this.showResources = false
    },
    removeResource(meeting) {
      this.$set(this.selectedResources, meeting.uuid, null)
    },
    selectedResource(uuid) {
      return this.selectedResources[uuid] != null ? this.selectedResources[uuid] : null
    },
  },
}
</script>
